import { useMeApi } from 'apis/users/use-me-api';
import { Box, Flex, HStack, LogoDot, Text } from 'design-system';
import { BasketBar } from 'pages/sales-lookup/components/basket-bar';
import { RestaurantPicker } from 'pages/sales-lookup/components/restaurant-picker';
import { ReactNode } from 'react';

// The module's own chrome: dark header with the customer selector, content
// clamped to a phone-ish column so the same screen also reads fine on a
// desktop browser. No sidebar — this page is built for a phone in a kitchen.
export const MobileShell = ({ children }: { children: ReactNode }) => {
  const { data: me } = useMeApi();
  const initials =
    String(me?.name ?? me?.email ?? '?')
      .trim()
      .slice(0, 2)
      .toUpperCase() || '?';

  return (
    <Flex direction='column' h='100vh' overflow='hidden' bg='#F4F5F7'>
      <Box bg='#141927' px='16px' pt='14px' pb='14px' flexShrink={0}>
        <Box maxW='480px' mx='auto'>
          <Flex align='center' justify='space-between'>
            <HStack spacing='8px'>
              <LogoDot boxSize='16px' />
              <Box
                bg='red.600'
                color='white'
                fontSize='10px'
                fontWeight='bold'
                letterSpacing='0.12em'
                px='8px'
                py='2px'
                borderRadius='full'>
                INTERNAL
              </Box>
            </HStack>
            <Flex align='center' justify='center' w='32px' h='32px' borderRadius='full' bg='red.700'>
              <Text color='white' fontSize='12px' fontWeight='bold'>
                {initials}
              </Text>
            </Flex>
          </Flex>
          <Box mt='10px'>
            <RestaurantPicker />
          </Box>
        </Box>
      </Box>

      {/* The CMS disables document scrolling globally (body { overflow: hidden }
          in assets/scss/custom/_common.scss) — every layout scrolls inside a
          container. This box is the mobile screens' scroll container; without
          it nothing on these routes scrolls at all. */}
      <Box flex='1' overflowY='auto' data-scroll-root>
        <Box w='full' maxW='480px' mx='auto' px='16px' py='16px'>
          {children}
        </Box>
      </Box>

      <BasketBar />
    </Flex>
  );
};
